module.exports = __webpack_public_path__ + "prod/1.42.2/img/ban-bj.5db20462.png";